import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { Draft } from "immer";
import { ApiEndpoints, baseQueryWithAuth } from "../../../core";

interface ApiResponse<T = any> {
  success: boolean;
  message: string;
  result?: T;
  results?: T;
}

export const formatApi = createApi({
  reducerPath: "formatApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Formats"],

  endpoints: (builder) => ({
    getFormats: builder.query<any, string>({
      query: (categoryId) => ({
        url: `${ApiEndpoints.getAllFormats}/${categoryId}`,
        method: "GET",
      }),
      providesTags: ["Formats"],
    }),
  }),
});

export const { useGetFormatsQuery } = formatApi;
